export const ACTIVE_MARKER_OPACITY = 1;
export const INACTIVE_MARKER_OPACITY = 0.4;
